import { useState } from 'react'
// import { useNavigate } from 'react-router-dom'

// import { IsAdmin } from 'app/IsAdmin'
// import PlusICon from 'assets/icons/PlusIcon.svg'
// import { Button } from 'components/Button'

import { BrandFilter } from './BrandFilter'
import { BrandSearch } from './BrandSearch'
import { BrandSort } from './BrandSort'
import BrandTable from './BrandTable'
import { useBrands } from '../../api/queries/useBrandDetails'

export const BrandList = () => {
  // const navigate = useNavigate()
  const [sortedBy, setSortedBy] = useState('Recent')
  const [searchTerm, setSearchTerm] = useState('')
  const [version, setVersion] = useState('ALL')
  const [appliedSearch, setAppliedSearch] = useState('')
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } = useBrands({
    searchTerm: appliedSearch,
    version,
    sortedBy,
  })
  const brands = data?.pages.flatMap(page => page.data) ?? []

  const totalResults = data?.pages?.[0]?.meta?.total ?? 0

  return (
    <>
      <div className="container-body  mx-auto">
        <div className="header-layout-brandlist flex justify-between items-center self-stretch">
          <div className="header-brandlist-left-panel">
            {/* Create new BVA button */}
            {/* <IsAdmin>
              <Button
                className="btn-big btn--primary create-button subtitle-s"
                onClick={() => navigate('/BVAFrameworks/create')}
                text="Create new BVA"
                icon={<img src={PlusICon} alt="Create" className="ml-2" width="16" height="16" />}
              />
            </IsAdmin> */}
          </div>
          <div className="header-brandlist-right-panel flex gap-4 items-center">
            <BrandSearch value={searchTerm} onChange={setSearchTerm} onSearch={setAppliedSearch} />
            {/* BVA Filter */}
            <BrandFilter version={version} setVersion={setVersion} />
            {/* Sort Options */}
            {/* SORT */}
            <BrandSort value={sortedBy} onChange={setSortedBy} />
          </div>
        </div>

        <BrandTable
          brands={brands}
          loadMore={fetchNextPage}
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          isLoading={isLoading}
          totalResults={totalResults}
          appliedSearch={appliedSearch}
        />
      </div>
    </>
  )
}
